import type { Ref } from 'vue'

type NewOrderForm = {
  type: 'Dine-in' | 'Takeaway' | 'Delivery'
  tableId: number | string | null
  customerName: string
  notes: string
  items: Array<{
    menu_item_id: number
    variant_id?: number | null
    quantity: number
    notes?: string
    special_instructions?: string
    unit_price?: number
    extras?: Array<{ name: string; price: number; quantity: number }>
  }>
}

interface UseNewOrderModalFormResetOptions<TMenuItem> {
  form: Ref<NewOrderForm>
  posMode: Ref<boolean>
  menuItems: Ref<TMenuItem[]>
  selectedItem: Ref<unknown>
  selectedVariant: Ref<unknown>
  itemNotes: Ref<string>
  showItemModal: Ref<boolean>
  createInitialFormItem: (item: TMenuItem) => NewOrderForm['items'][number]
  resetMultipleDiners: () => void
}

export function useNewOrderModalFormReset<TMenuItem>(options: UseNewOrderModalFormResetOptions<TMenuItem>) {
  const getInitialForm = (): NewOrderForm => {
    return {
      type: options.posMode.value ? 'Takeaway' : 'Dine-in',
      tableId: null,
      customerName: '',
      notes: '',
      items: []
    }
  }

  const resetForm = () => {
    options.form.value = getInitialForm()
    options.selectedItem.value = null
    options.selectedVariant.value = null
    options.itemNotes.value = ''
    options.showItemModal.value = false

    if (options.menuItems.value.length > 0) {
      options.form.value.items = options.menuItems.value.map((item) => options.createInitialFormItem(item))
    }

    options.resetMultipleDiners()
  }

  return {
    resetForm
  }
}
